import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { intlShape } from 'react-intl'
import * as shapes from '../../constant/shapes'
import MiniPlayer from '../miniPlayer/MiniPlayer'
import * as selectors from '../miniPlayer/miniPlayerSelectors'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'


class TrackItem extends PureComponent {

	render() {
		const { fields, track } = this.props
		return (
			<div className="item">
				{fields.map((field, key) => (
					<span key={`trackitem-${track.id}-${key}`} className={`track-${field.type} ${key !== 0 && 'text-overflow'}`}>
						{field.render(track)}
						{key === 0 && <MiniPlayer
							element={track}
							buttonClassName="track-player"
							type={ORIGIN_PLAYQUEUE_TYPES.track}
							sampleable={track.sampleable}
						/>}
					</span>
				))}
			</div>
		)
	}

}

TrackItem.propTypes = {
	fields: PropTypes.arrayOf(PropTypes.shape({
		type: PropTypes.string,
		render: PropTypes.func
	})).isRequired,
	track: shapes.trackItem.isRequired,
	idCurrentTrack: PropTypes.number
}

TrackItem.contextTypes = {
	intl: intlShape
}

const mapStateToProps = state => ({
	idCurrentTrack: selectors.getIdCurrentTrack(state)

})


export default connect(mapStateToProps)(TrackItem)



// WEBPACK FOOTER //
// ./src/components/tracklist/TrackItem.jsx